import { useEffect } from "react";
import { makeEnumFriendly } from "../../enum";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";
import { fetchProductTypes } from "../../redux/productTypesSlice";
import FilterableForm from "../common/filterableForm";


interface ProductFilterProps {
  onClose: () => void;
}

function ProductFilter({ onClose }: ProductFilterProps) {  


  const productTypes = useSelector((state: RootState) => state.productTypes);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!productTypes.loaded) {
      dispatch(fetchProductTypes() as any);
    }
  }, []);

  return (
    
    <FilterableForm
      title="Product Filters"
      fields={[
          { name: "id", label: "ID", type: "number", defaultValue: "" },
          { name: "alias", label: "Alias", type: "text", defaultValue: "" },
          { name: "product_type", label: "Product Type", type: "select", options: makeEnumFriendly(productTypes.results), defaultValue: "" },
          { name: "variant_sku", label: "variant sku", type: "text", defaultValue: 0 },
          { name: "variant_id", label: "variant id", type: "number", defaultValue: 0 },
          { name: "is_multi_variant", label: "Is Multi Variant", type: "checkbox" },
      ]}
      onClose={onClose}
    />



  );
}


export default ProductFilter;
